/** How many of a currency's smallest units make up one major unit (e.g. 100 cents per dollar). */
const SMALLEST_UNITS_PER_MAJOR_UNIT = 100;

/**
 * Converts a smallest-unit amount (Stripe convention, e.g. cents) to its major unit (e.g. dollars),
 * for seeding an input that a user reads and edits in major units.
 *
 * @param amount - The amount in the currency's smallest unit.
 * @returns The equivalent major-unit amount, which may have a fractional part.
 *
 * @example
 * toMajorCurrencyUnit(2500) // 25
 */
export const toMajorCurrencyUnit = (amount: number): number => amount / SMALLEST_UNITS_PER_MAJOR_UNIT;

/**
 * Converts a major-unit amount (e.g. dollars, as typed by a user) to the smallest unit (e.g. cents)
 * that the API stores, rounding to a whole unit so a fractional cent is never submitted.
 *
 * @param amount - The amount in the currency's major unit.
 * @returns The equivalent whole smallest-unit amount.
 *
 * @example
 * toSmallestCurrencyUnit(25.99) // 2599
 */
export const toSmallestCurrencyUnit = (amount: number): number => Math.round(amount * SMALLEST_UNITS_PER_MAJOR_UNIT);
